import { usePaginatedQuery } from 'convex/react'
import { api } from '@backend/_generated/api'

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ConvexDirectReportPosition {
  _id: string
  title: string
  level: string
  role: string
}

export interface ConvexDirectReportPendingAssessment {
  assessmentId: string
  responseId: string
}

/** A direct report as returned by `listDirectReports`. */
export interface ConvexDirectReport {
  /** The managerRelation document ID. */
  _id: string
  /** The employee's Convex user `_id` — use this as the employee ID for mutations. */
  userId: string
  name: string | null
  email: string | null
  image: string | null
  username: string | null
  organizationId: string
  position: ConvexDirectReportPosition | null
  /** Set when the manager has an incomplete response on an existing assessment. */
  pendingAssessment: ConvexDirectReportPendingAssessment | null
}

// ─── Hooks ────────────────────────────────────────────────────────────────────

const PAGE_SIZE = 20

/**
 * Paginated list of the current manager's direct reports.
 *
 * Returns `{ results, status, loadMore }` — use `status === 'CanLoadMore'` and
 * `loadMore(n)` for the Load More pattern.
 */
export function useMyDirectReports() {
  return usePaginatedQuery(
    api.directReports.listDirectReports,
    {},
    { initialNumItems: PAGE_SIZE },
  )
}
